import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IStoreReadStatusResponse } from "@api/stores/readStatus/types";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IStoreReadStatusResponse>,
  IPathBaseParam,
  object
>("stores.readStatus");

export const readStatus = {
  ...getApis,
};
